import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import withStyles from '@material-ui/core/styles/withStyles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import navPillsStyle from '../../assets/jss/material-kit-react/components/navPillsStyle';
class NavPills extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = (event, active) => {
            this.setState({ active });
        };
        this.handleChangeIndex = index => {
            this.setState({ active: index });
        };
        this.state = {
            active: props.active,
        };
    }
    render() {
        const { classes, tabs, direction, color, horizontal, alignCenter, } = this.props;
        const flexContainerClasses = classNames({
            [classes.flexContainer]: true,
            [classes.horizontalDisplay]: horizontal !== undefined,
        });
        const tabButtons = (React.createElement(Tabs, { classes: {
                root: classes.root,
                fixed: classes.fixed,
                flexContainer: flexContainerClasses,
                indicator: classes.displayNone,
            }, value: this.state.active, onChange: this.handleChange, centered: alignCenter }, tabs.map((prop, key) => {
            var icon = {};
            if (prop.tabIcon !== undefined) {
                icon['icon'] = React.createElement(prop.tabIcon, { className: classes.tabIcon });
            }
            const pillsClasses = classNames({
                [classes.pills]: true,
                [classes.horizontalPills]: horizontal !== undefined,
                [classes.pillsWithIcons]: prop.tabIcon !== undefined,
            });
            return (React.createElement(Tab, Object.assign({ label: prop.tabButton, key: key }, icon, { classes: {
                    root: pillsClasses,
                    labelContainer: classes.labelContainer,
                    label: classes.label,
                    selected: classes[color],
                } })));
        })));
        const tabContent = (React.createElement("div", { className: classes.contentWrapper },
            React.createElement(SwipeableViews, { axis: direction === 'rtl' ? 'x-reverse' : 'x', index: this.state.active, onChangeIndex: this.handleChangeIndex }, tabs.map((prop, key) => {
                return (React.createElement("div", { className: classes.tabContent, key: key }, prop.tabContent));
            }))));
        return horizontal !== undefined ? (React.createElement(GridContainer, null,
            React.createElement(GridItem, Object.assign({}, horizontal.tabsGrid), tabButtons),
            React.createElement(GridItem, Object.assign({}, horizontal.contentGrid), tabContent))) : (React.createElement("div", null,
            tabButtons,
            tabContent));
    }
}
NavPills.defaultProps = {
    active: 0,
    color: 'primary',
};
NavPills.propTypes = {
    classes: PropTypes.object.isRequired,
    active: PropTypes.number,
    tabs: PropTypes.arrayOf(PropTypes.shape({
        tabButton: PropTypes.string,
        tabIcon: PropTypes.func,
        tabContent: PropTypes.node,
    })).isRequired,
    color: PropTypes.oneOf([
        'primary',
        'warning',
        'danger',
        'success',
        'info',
        'rose',
    ]),
    direction: PropTypes.string,
    horizontal: PropTypes.shape({
        tabsGrid: PropTypes.object,
        contentGrid: PropTypes.object,
    }),
    alignCenter: PropTypes.bool,
};
export default withStyles(navPillsStyle)(NavPills);
//# sourceMappingURL=NavPills.js.map